import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {
  type RepoStackDetailResponse,
  RepoStackDetailResponseSchema,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {repoAppBuilder} from '@github-ui/repo-app-builder'

export const REPO_STACK_DETAIL_PATH = '/:owner/:repo/stack/:number'

export function buildRepoStackDetailRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoStackDetailRoute', {
    path: REPO_STACK_DETAIL_PATH,
    queries: [
      mainQuery<RepoStackDetailResponse>({
        schema: RepoStackDetailResponseSchema,
        queryDeps: ({pathname}) => ({pathname}),
      }),
    ],
  })
}

export const repoStackDetailRoute = buildRepoStackDetailRoute(repoAppBuilder)
